import { render } from "./ContentSettings.vue?vue&type=template&id=02a94f5b"
import script from "./ContentSettings.vue?vue&type=script&lang=js"
export * from "./ContentSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/organization_profile/ContentSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02a94f5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02a94f5b', __exports__)) {
    api.reload('02a94f5b', __exports__)
  }
  
  module.hot.accept("./ContentSettings.vue?vue&type=template&id=02a94f5b", () => {
    api.rerender('02a94f5b', render)
  })

}


export default __exports__